import { useContext, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Heading } from '../../../../v2/js/components/heading';
import { MAIN_CONTENT_AREA } from '../../../../v2/js/utils/layoutStyles';
import { SessionContext } from '../../../app/contexts/SessionContext';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { InviteUserDialog } from '../InviteUserDialog';
import { UsersList } from './UsersList';

export const HealthcareEntityUsersList = () => {
  useDocumentTitle('Users list');
  const [showInviteDialog, setShowInviteDialog] = useState(false);
  const { user } = useContext(SessionContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.group_names?.includes('manage_users')) {
      navigate('/');
    }
  }, [user]);

  return (
    <>
      <main className={MAIN_CONTENT_AREA}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Heading level={1} className="tw:!text-brand-green-0 tw:dark:!text-zinc-100 tw:!mb-0">
            <i className="far fa-fw fa-id-badge tw:mr-1" />
            Users
          </Heading>
          <div>
            <LinkContainer to="/app/healthcare-entity/pending-invitations">
              <Button variant="primary" className="me-2">
                Pending Invitations
              </Button>
            </LinkContainer>
            <Button variant="primary" onClick={() => setShowInviteDialog(true)}>
              Invite User
            </Button>
            <InviteUserDialog show={showInviteDialog} onClose={() => setShowInviteDialog(false)} />
          </div>
        </div>
        <Row className="justify-content-center" xs={12}>
          <Col>
            <UsersList />
          </Col>
        </Row>
      </main>
    </>
  );
};
